export default "__VITE_ASSET__BxDiABqu__"